



































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import storeCutiBersalin from "@/store/modules/SuratCutiBersalinStore";
import SuratCutiBersalinSvc from "@/services/SuratCutiBersalin";
import FormPrefillService from "@/services/FormPrefillService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { storePasien } from "@/store/modules/pasien";
import { calculateTp } from "@/utils/kebidananCalculator";
import { maskTekananDarah } from "@/utils/tekananDarah";

const FORM_KEY = "surat_cuti_bersalin";
const PREFILL_SOURCES = ["klinis_terkini", "administratif", "obstetri"];

const TANGGAL_FIELDS = ["hpht", "tp", "tgl_surat", "tgl_tanda_tangan"];
const RENTANG_TD = { sistole: [60, 260], diastole: [30, 160] };

type NilaiTd = string | number | null | undefined;

function composeTd(sistole: NilaiTd, diastole: NilaiTd): string {
  const s = sistole === null || sistole === undefined ? "" : String(sistole).trim();
  const d = diastole === null || diastole === undefined ? "" : String(diastole).trim();
  return !s && !d ? "" : `${s}/${d}`;
}

function tanggalKeDate(val: string | Date | null): Date | null {
  if (!val) return null;
  if (val instanceof Date) return val;
  const [y, m, d] = String(val).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

@Component({
  components: { CardModalTtd, VCDateTimePicker },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSuratCutiBersalin extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  dialogForm = false;
  isEditing = false;
  formValid = false;
  saving = false;
  modalTtd = false;
  tarikLoading = false;
  hydratingForm = false;
  lanjutTtd = false;
  selectedItem: any = null;

  form: any = this.getEmptyForm();

  metodeTpOptions = [
    { text: "Naegele (dari HPHT)", value: "naegele" },
    { text: "USG Trimester 1", value: "usg_tri1" },
    { text: "USG Trimester 2", value: "usg_tri2" },
    { text: "Tinggi Fundus Uteri", value: "fundus" }
  ];
  golDarahOptions = [
    "A",
    "B",
    "AB",
    "O",
    "A+",
    "A-",
    "B+",
    "B-",
    "AB+",
    "AB-",
    "O+",
    "O-"
  ];

  headers = [
    { text: "No", value: "no", sortable: false, width: 50 },
    { text: "Nomor", value: "nomor" },
    { text: "Keperluan", value: "keperluan", sortable: false },
    { text: "Tgl Surat", value: "tgl_surat", width: 120 },
    { text: "Status", value: "status", sortable: false, width: 130 },
    { text: "Aksi", value: "aksi", sortable: false, width: 180 }
  ];

  mounted() {
    storeCutiBersalin.getByRegister(this.register);
  }

  get loading() {
    return storeCutiBersalin.loading;
  }
  get items() {
    return storeCutiBersalin.items;
  }
  get currentUserId() {
    return userModule.user?.id;
  }
  get isPasienLaki() {
    const p = storePasien.identitasPasien;
    return !!p && p.jk === "Laki-laki";
  }

  get today() {
    return localISODate();
  }

  get tanggalDate(): Record<string, Date | null> {
    const out: Record<string, Date | null> = {};
    TANGGAL_FIELDS.forEach(f => {
      out[f] = tanggalKeDate(this.form[f]);
    });
    return out;
  }

  setTanggal(field: string, val: Date | null) {
    this.form[field] = val ? localISODate(val) : null;
  }

  onTdInput(val: string) {
    const bersih = maskTekananDarah(val, String(this.form.td || ""));

    this.form.td = bersih;

    if (bersih !== val) {
      const field = this.$refs.tdRef as { lazyValue?: string };
      if (field) field.lazyValue = bersih;
    }
  }

  get tdRules() {
    return [
      (v: string) => {
        if (!v) return true;
        const cocok = /^(\d{1,3})\/(\d{1,3})$/.exec(v);
        if (!cocok) return "Format tekanan darah: xxx/xx, misal 120/80";

        const nilai = { sistole: Number(cocok[1]), diastole: Number(cocok[2]) };
        for (const bagian of ["sistole", "diastole"] as const) {
          const [min, max] = RENTANG_TD[bagian];
          if (nilai[bagian] < min || nilai[bagian] > max) {
            return `${bagian === "sistole" ? "Sistole" : "Diastole"} di luar rentang ${min}-${max} mmHg`;
          }
        }
        if (nilai.sistole <= nilai.diastole) {
          return "Sistole harus lebih tinggi dari diastole";
        }

        return true;
      }
    ];
  }

  get keperluanRules() {
    return [
      (v: any) => !!v || "Wajib diisi",
      (v: any) =>
        !v || v.length <= 200 || "Maksimal 200 karakter agar surat tetap 1 halaman"
    ];
  }

  get imtPreview() {
    const bb = Number(this.form.bb);
    const tb = Number(this.form.tb);
    if (!bb || !tb || bb <= 0 || tb <= 0) return "-";
    const imt = bb / Math.pow(tb / 100, 2);
    if (!isFinite(imt)) return "-";
    return imt.toFixed(2) + " " + this.ketImt(imt);
  }

  ketImt(v: number) {
    if (v >= 30) return "(Obesitas)";
    if (v >= 25) return "(Overweight)";
    if (v >= 18.5) return "(Normal)";
    return "(Underweight)";
  }

  @Watch("form.hpht")
  onHphtChange(val: string) {
    if (this.hydratingForm) return;
    if (val) {
      const tp = calculateTp(val);
      if (tp) this.form.tp = tp;
      if (!this.form.metode_tp) this.form.metode_tp = "naegele";
    }
  }

  getEmptyForm() {
    const today = localISODate();
    return {
      keperluan: "",
      keterangan: "",
      hpht: null,
      tp: null,
      metode_tp: null,
      td: "",
      nadi: null,
      tb: "",
      bb: "",
      gol_darah: storePasien.identitasPasien
        ? (storePasien.identitasPasien as any).gol_darah || null
        : null,
      tgl_surat: today,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: today
    };
  }

  formatTanggal(val: string | null) {
    if (!val) return "-";
    const parts = val.slice(0, 10).split("-");
    if (parts.length !== 3) return val;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  canEditItem(item: any) {
    if (this.readOnly) return false;
    return !item.signed_penerbit && item.creator_user_id == this.currentUserId;
  }

  canDeleteItem(item: any) {
    if (this.readOnly) return false;
    if (item.creator_user_id != this.currentUserId) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [{ ditandatangani: item.signed_penerbit, penandaTanganId: item.penerbit_user_id }],
      this.currentUserId
    );
  }

  refreshList() {
    storeCutiBersalin.getByRegister(this.register);
  }

  openCreate() {
    this.form = this.getEmptyForm();
    this.isEditing = false;
    this.selectedItem = null;
    this.dialogForm = true;
  }

  openEdit(item: any) {
    if (item.signed_penerbit) return;
    this.hydratingForm = true;
    this.form = {
      keperluan: item.keperluan || "",
      keterangan: item.keterangan || "",
      hpht: item.hpht,
      tp: item.tp,
      metode_tp: item.metode_tp,
      td: item.td || "",
      nadi: item.nadi,
      tb: item.tb || "",
      bb: item.bb || "",
      gol_darah: item.gol_darah || null,
      tgl_surat: item.tgl_surat,
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan
    };
    this.selectedItem = item;
    this.isEditing = true;
    this.dialogForm = true;
    this.$nextTick(() => {
      this.hydratingForm = false;
    });
  }

  async tarikDataRme() {
    if (this.tarikLoading) return;
    this.tarikLoading = true;

    try {
      const payload = await FormPrefillService.fetchPrefill(this.rm, FORM_KEY, {
        register_id: this.register,
        unit_id: userModule.user?.unit_id || "",
        sources: PREFILL_SOURCES
      });

      const fields = (payload && payload.fields) || {};
      const form = { ...this.form };
      const terisi: string[] = [];

      const isFilled = (v: any) => v !== undefined && v !== null && v !== "";

      const sistole = fields["nb.sistole"];
      const diastole = fields["nb.diastole"];
      if (isFilled(sistole) || isFilled(diastole)) {
        form.td = composeTd(
          isFilled(sistole) ? sistole : "",
          isFilled(diastole) ? diastole : ""
        );
        if (isFilled(sistole)) terisi.push("nb.sistole");
        if (isFilled(diastole)) terisi.push("nb.diastole");
      }

      const map: Record<string, string> = {
        "nb.nadi": "nadi",
        "nb.tb": "tb",
        "nb.bb": "bb",
        "nb.gol_darah": "gol_darah",
        "nb.hpht": "hpht"
      };
      Object.keys(map).forEach(path => {
        const v = fields[path];
        if (!isFilled(v)) return;
        form[map[path]] = v;
        terisi.push(path);
      });

      this.form = form;

      if (isFilled(form.hpht)) {
        const tp = calculateTp(form.hpht);
        if (tp) this.form.tp = tp;
        if (!this.form.metode_tp) this.form.metode_tp = "naegele";
      }

      if (terisi.length > 0) {
        appModule.NoticeDelay(
          terisi.length + " kolom terisi dari catatan kunjungan ini"
        );
        FormPrefillService.logAcceptance({
          form_key: FORM_KEY,
          pasien_rm: this.rm,
          register_id: this.register,
          unit_id: userModule.user?.unit_id || "",
          event: "accepted",
          fields: terisi,
          provenance: (payload && payload.provenance) || {},
          sources: PREFILL_SOURCES
        });
      } else {
        appModule.sendErrorAlert(
          "Belum ada tanda vital, antropometri, atau HPHT yang tercatat pada kunjungan ini"
        );
      }
    } finally {
      this.tarikLoading = false;
    }
  }

  async simpan(lanjutTtd = false) {
    if (this.saving) return;
    this.saving = true;
    this.lanjutTtd = lanjutTtd;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user?.unit_id || "",
        ...this.form
      };

      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await SuratCutiBersalinSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await SuratCutiBersalinSvc.create(payload);
      }

      if (resp.data.status == "1" || resp.data.status == 1) {
        appModule.NoticeDelay("Surat Keterangan Cuti Bersalin berhasil disimpan");
        const tersimpan = resp.data.data || this.selectedItem;
        this.dialogForm = false;
        this.form = this.getEmptyForm();
        this.selectedItem = null;
        this.refreshList();

        if (lanjutTtd && tersimpan && tersimpan.id) {
          this.openTtd(tersimpan);
        }
      }
    } finally {
      this.saving = false;
      this.lanjutTtd = false;
    }
  }

  openTtd(item: any) {
    this.selectedItem = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const resp = await SuratCutiBersalinSvc.signPenerbit(this.selectedItem.id, {
      password
    });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil menandatangani surat");
      appModule.addMsgTtd("");
      this.refreshList();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf(item: any) {
    SuratCutiBersalinSvc.print(item.id);
  }

  async hapus(item: any) {
    if (!this.canDeleteItem(item)) return;
    if (!confirm("Yakin ingin menghapus surat keterangan cuti bersalin ini?")) return;

    const resp = await SuratCutiBersalinSvc.destroy(item.id);
    if (resp.data?.status == 1 || resp.data?.status == "1") {
      appModule.NoticeDelay("Berhasil menghapus data");
      this.refreshList();
    }
  }
}
